window.initMap = () => {
  var praxis = {
    lat: 49.22515260209491,
    lng: 12.661253355861351
  }
  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 16,
    center: praxis,
    styles: [
      {
        featureType: "poi",
        stylers: [
          {
            visibility: "off"
          }
        ]
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on"
          }
        ]
      }
    ]
  })
  var window = new google.maps.InfoWindow({
    content:
      '<h4 class="mb-2">Praxis</h4><p>Kalvarienbergweg 10<br>93413 Cham - Deutschland</p>'
  })
  var marker = new google.maps.Marker({
    position: praxis,
    animation: google.maps.Animation.DROP,
    map: map,
    icon: {
      url: '/wp-content/uploads/2024/04/icon-pin.svg',
      scaledSize: {
        width: 26,
        height: 37
      }
    }
  })

  var parkingSpots = [
    {
      position: {
        lat: 49.22489139994747,
        lng: 12.663008769355365
      }
    }
  ]

  parkingSpots.forEach(parkingSpot => {
    new google.maps.Marker({
      position: parkingSpot.position,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: {
        url: '/wp-content/uploads/2024/04/icon-parking.svg',
        scaledSize: {
          width: 26,
          height: 37
        }
      }
    })
  })

  var trainStations = [
    {
      position: {
        lat: 49.22240447064678,
        lng: 12.657130066991025
      }
    }
  ]

  trainStations.forEach(trainStation => {
    new google.maps.Marker({
      position: trainStation.position,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: {
        url: '/wp-content/uploads/2024/04/icon-train.svg',
        scaledSize: {
          width: 26,
          height: 37
        }
      }
    })
  })

  try {
    marker.addListener('click', () => {
      window.open(map, marker)
    })
  } catch (err) {}
}
